import { Grid } from '@mui/material';

const AlphaBankForm = () => {
    return (
        <Grid item xs={12}>
            <form id="paymentForm_AlphaBank" method="POST">
                <input id="version" name="version" value="2" type="hidden" />
                <input id="mid" name="mid" type="hidden" />
                <input id="lang" name="lang" type="hidden" />
                <input id="orderid" name="orderid" type="hidden" />
                <input id="orderDesc" name="orderDesc" type="hidden" />
                <input id="orderAmount" name="orderAmount" type="hidden" />
                <input id="currency" name="currency" type="hidden" />
                <input id="payerEmail" name="payerEmail" type="hidden" />
                <input id="payerPhone" name="payerPhone" type="hidden" />
                <input id="billCountry" name="billCountry" type="hidden" />
                <input id="billZip" name="billZip" type="hidden" />
                <input id="billCity" name="billCity" type="hidden" />
                <input id="billAddress" name="billAddress" type="hidden" />
                <input id="confirmUrl" name="confirmUrl" type="hidden" />
                <input id="cancelUrl" name="cancelUrl" type="hidden" />
                <input id="digest" name="digest" type="hidden" />
            </form>
        </Grid>
    );
};

export default AlphaBankForm;
